import type { DevOpsPlatformValue } from '../constants/DevOpsPlatform';

export type ParsedDevOpsUrl = {
  platform: DevOpsPlatformValue;
  externalId?: string;
  externalType?: string;
  externalTitle?: string;
};

const AZURE_DEVOPS_EDIT =
  /dev\.azure\.com\/[^/]+\/[^/]+\/_workitems\/edit\/(\d+)/i;
const AZURE_DEVOPS_VISUAL_STUDIO =
  /visualstudio\.com\/[^/]+\/_workitems\/edit\/(\d+)/i;
const JIRA_BROWSE = /\/browse\/([A-Z][A-Z0-9]+-\d+)/i;
const JIRA_SELECTED =
  /[?&]selectedIssue=([A-Z][A-Z0-9]+-\d+)/i;

export function parseDevOpsUrl(url: string): ParsedDevOpsUrl | null {
  const trimmed = url.trim();
  if (!trimmed) return null;

  let parsed: URL;
  try {
    parsed = new URL(trimmed);
  } catch {
    return null;
  }

  const href = parsed.href;

  const azureMatch = href.match(AZURE_DEVOPS_EDIT) ?? href.match(AZURE_DEVOPS_VISUAL_STUDIO);
  if (azureMatch) {
    return {
      platform: 'AzureDevOps',
      externalId: azureMatch[1],
      externalType: 'WorkItem',
    };
  }

  const jiraBrowse = href.match(JIRA_BROWSE);
  if (jiraBrowse) {
    return {
      platform: 'Jira',
      externalId: jiraBrowse[1],
      externalType: 'Issue',
    };
  }

  const jiraSelected = href.match(JIRA_SELECTED);
  if (jiraSelected) {
    return {
      platform: 'Jira',
      externalId: jiraSelected[1],
      externalType: 'Issue',
    };
  }

  if (href.includes('github.com') && href.includes('/issues/')) {
    const issueMatch = href.match(/\/issues\/(\d+)/);
    if (issueMatch) {
      return {
        platform: 'GitHubIssues',
        externalId: issueMatch[1],
        externalType: 'Issue',
      };
    }
  }

  if (href.includes('gitlab') && (href.includes('/-/issues/') || href.includes('/issues/'))) {
    const issueMatch = href.match(/issues\/(\d+)/);
    if (issueMatch) {
      return {
        platform: 'GitLab',
        externalId: issueMatch[1],
        externalType: 'Issue',
      };
    }
  }

  return null;
}
